<template>
  <div>
    <v-data-table
      v-if="jobList"
      :headers="headers"
      :items="jobList"
      :loading="isLoading"
      :items-per-page="20"
      :footer-props="footerProps"
      class="elevation-1"
      @click:row="handleClick"
    >
      <template v-slot:item.first_name="{ item }">
        <span>{{ item.first_name }} {{ item.last_name }}</span>
      </template>
      <template v-slot:item.status="{ item }">
        <div class="flex-center">
          <v-chip
            class="ma-2 v-chip-width"
            :color="getStatusChip(item).color"
          >
            <span class="text-white">
              {{ getStatusChip(item).status }}
            </span>
          </v-chip>
        </div>
      </template>
      <template v-if="isEdit" v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click.stop="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click.stop="deleteDialog(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <v-snackbar v-model="toastDeleteSuccess" :timeout="2000">
      ลบสำเร็จ
      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="toastDeleteSuccess = false"
        >
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
    <!-- Delete Dialog -->
    <v-dialog v-model="dialogDelete" persistent width="390">
      <v-card>
        <v-card-title class="text-h5 text-red">
          ยืนยันลบรายการนี้หรือไม่
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialogDelete = false"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="confirmDeleteItem"
          >
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Delete Dialog -->
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      jobList: (state) => state.job.jobList,
      isLoading: (state) => state.job.isLoading,
      isEdit: (state) => state?.me?.data?.permission?.stock_edit,
    }),
    dateRangeText() {
      return this.dates.join(` ~ `)
    },
  },

  props: {
    data: Object,
  },

  data() {
    return {
      footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
      dialogDelete: false,
      deleteItem: null,
      headers: [
        {
          text: 'หมายเลขงาน',
          value: 'id',
          align: 'center',
          width: '100px',
        },
        {
          text: 'วันที่',
          value: 'date',
          align: 'start',
          width: '150px',
        },
        {
          text: 'ชื่อ',
          value: 'name',
          align: 'start',
          width: '200px',
        },
        {
          text: 'สถานะ',
          value: 'status',
          align: 'center',
          width: '250px',
        },
        {
          text: 'วันเวลาที่เริ่ม',
          value: 'started_timestamp',
          align: 'start',
          width: '150px',
        },
        {
          text: 'สิ้นสุดเวลา',
          value: 'expired_timestamp',
          align: 'start',
          width: '150px',
        },
        {
          text: 'เวลาสร้าง',
          value: 'created_timestamp',
          align: 'start',
          width: '150px',
        },
        {
          text: 'สร้างโดย',
          value: 'emp_name',
          align: 'start',
          width: '170px',
        },
        {
          text: 'วันที่สรุปงาน',
          value: 'cal_at',
          align: 'start',
          width: '150px',
        },

        {
          text: 'เครื่องมือ',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '80px',
          fixed: true,
        },
      ],
      toastDeleteSuccess: false,
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
    }
  },

  methods: {
    handleClick(value) {
      this.$router.push({
        name: 'JobDetail',
        params: {
          id: value.id,
        },
      })
    },
    deleteDialog(value) {
      this.dialogDelete = true
      this.deleteItem = value
    },
    async confirmDeleteItem() {
      await this.$store.dispatch('job/deleteJob', {
        job_id: this.deleteItem?.id,
      })
      this.toastDeleteSuccess = true
      this.dialogDelete = false
      this.$emit('delete')
    },
    editItem(value) {
      this.$router.push({
        name: 'EditJob',
        params: {
          id: value.id,
        },
      })
    },
    getStatusChip(val) {
      if (moment() < moment(val?.started_timestamp)) {
        return {
          status: 'ยังไม่ถึงกำหนดเริ่ม',
          color: '#727272',
        }
      } else if (
        moment() >= moment(val?.started_timestamp) &&
        moment() <= moment(val?.expired_timestamp)
      ) {
        return {
          status: 'อยู่ระหว่างการตรวจสอบ',
          color: '#f5a400',
        }
      } else if (
        moment() > moment(val?.expired_timestamp) &&
        !val?.cal_at
      ) {
        return {
          status: 'หมดเวลา',
          color: '#ff6b02',
        }
      } else if (
        moment() > moment(val?.expired_timestamp) &&
        val?.cal_at
      ) {
        return {
          status: 'ประมวลผลแล้ว',
          color: 'green',
        }
      } else {
        return {
          status: 'เกิดข้อผิดพลาด',
          color: '#ff7b71',
        }
      }
    },
  },
}
</script>

<style>
.v-chip-width {
  width: 80%;
  padding: 0 10px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.text-white {
  color: white;
}
</style>

<style scoped>
/deep/ table > tbody > tr > td:nth-child(10),
/deep/ table > thead > tr > th:nth-child(10) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  z-index: 9;
  background: white;
}
/deep/ table > thead > tr > th:nth-child(10) {
  z-index: 10;
}
</style>
